import { ApolloProvider } from '@apollo/client/react'
import { ChakraProvider } from '@chakra-ui/react'
import 'ag-grid-enterprise'
import { FocusEvent, KeyboardEvent, createRef } from 'react'
import { RouterProvider } from 'react-router-dom'
import 'simplebar-react/dist/simplebar.min.css'

import { ErrorBoundary } from './components/ErrorBoundary/ErrorBoundary'
import { AppError } from './components/Errors/AppError'
import { SplashPage } from './pages/SplashPage'
import { apolloClient } from './services/apolloClient'
import { useAppStore } from './store/appStore/appStore'
import { theme } from './theme/theme'

export const topbarRef = createRef<HTMLDivElement>()
export const toastPortalRef = createRef<HTMLDivElement>()

export const App = () => {
  const { status, router } = useAppStore(({ status, router }) => {
    return {
      status,
      router: router.router,
    }
  })

  if (status !== 'started') {
    return <SplashPage />
  }

  return (
    <ChakraProvider
      theme={theme}
      toastOptions={{
        portalProps: {
          containerRef: toastPortalRef,
        },
      }}
    >
      <ErrorBoundary renderError={error => <AppError error={error} />}>
        <ApolloProvider client={apolloClient}>
          <div
            className="App"
            onKeyUp={(e: KeyboardEvent<HTMLElement>) => {
              // current element
              if (e.code === 'Tab') {
                const focusedElement = e.target as HTMLElement
                focusedElement.style.boxShadow = 'none'
                focusedElement.style.outline = '3px solid #4299e199'
                focusedElement.style.outlineOffset = '-3px'
              }
            }}
            onBlur={(e: FocusEvent<HTMLElement>) => {
              // previous element
              const focusedElement = e.target as HTMLElement
              focusedElement.style.outline = ''
              focusedElement.style.outlineOffset = ''
            }}
          >
            <RouterProvider router={router!} />
          </div>
        </ApolloProvider>
      </ErrorBoundary>
    </ChakraProvider>
  )
}
